import {getTitle} from "~/utils/getTitle";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { Case, If } from "~/common/components/If";
import PageHeader from "~/common/components/PageHeader";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router";
import Fee from "~/pages/mypage/admin/LicensePage/fee";
import Purchase from "~/pages/mypage/admin/LicensePage/purchase";
import useRequest from "~/common/hooks/useRequest";
import useAlert from "~/common/hooks/useAlert";
import { API_STATE } from "~/common/constants/state";
import { DateWithDayName } from "~/utils/formatter";

const License = () => {

    const { t } = useTranslation();

    const MENU = ["admin", "license"];
    const TYPE = "myPage";

    const location = useLocation();
    const navigate = useNavigate();

    const qs = queryString.parse(location.search);

    const [page, setPage] = useState(qs.info === "fail" ? "purchase" : "fee");
    const [purchaseInfo, setPurchaseInfo] = useState({});
    const [freeLicense, setFreeLicense] = useState(false);

    const [showSuccessAlert, SuccessAlert] = useAlert();
    const [showApplyAlert, ApplyAlert] = useAlert();
    const [showUnsubscriptionAlert, UnsubscriptionAlert] = useAlert();
    const [showExpiredLicenseAlert, ExpiredLicenseAlert] = useAlert();

    const purchaseInfoRequest = useRequest("get", "vc/admin/purchase/info");
    const unsubscriptionRequest = useRequest("get", "vc/admin/subscription/deactivate");

    const resetPage = () => {
        purchaseInfoRequest.call();
        qs &&
        qs.info === "success" &&
        showSuccessAlert().then(() => {
            navigate("/myPage/admin/license");
        });
    };

    const handleApplyButton = () => {
        if (purchaseInfo.licenseStatus === "free") {
            setPage("purchase");
            return;
        }
        setFreeLicense(true);
        showUnsubscriptionAlert().then(() => {
            unsubscriptionRequest.call();
        });
    };

    useEffect(() => {
        resetPage();
    }, []);

    useEffect(() => {
        switch (purchaseInfoRequest.state) {
            case API_STATE.done:
                const response = purchaseInfoRequest.response.data;
                setPurchaseInfo({
                    ...response.purchaseHistory,
                    members: response.invitedUsersCnt,
                    licenseStatus:
                        Object.keys(purchaseInfoRequest.response.data).length <= 1
                            ? "free"
                            : response.purchaseHistory.activation === true &&
                            response.purchaseHistory.expired === false
                                ? "enterprise"
                                : "free",
                });
                break;
            case API_STATE.error:
                break;
        }
    }, [purchaseInfoRequest.state]);

    useEffect(() => {
        switch (unsubscriptionRequest.state) {
            case API_STATE.done:
                showSuccessAlert();
                purchaseInfoRequest.call();
                break;
            case API_STATE.error:
                navigate("/404");
                break;
        }
    }, [unsubscriptionRequest.state]);

    return(
        <>
            <Helmet>
                <title>{getTitle(t("pages.myPage.admin.LicensePage.fee.title"))}</title>
            </Helmet>
            <NavbarAndSidebarLayout menu={["management", "license"]} type={"main"}>
                <PageHeader />
                <If
                    condition={page}
                    {...{
                        setPage,
                        purchaseInfo,
                        setPurchaseInfo,
                        resetPage,
                        unsubscriptionRequest,
                        handleApplyButton,
                        qs,
                        showSuccessAlert,
                        showApplyAlert,
                        ApplyAlert,
                        showUnsubscriptionAlert,
                        UnsubscriptionAlert,
                        showExpiredLicenseAlert,
                        ExpiredLicenseAlert,
                    }}
                >
                    <Case condition={"fee"}>
                        <Fee />
                    </Case>
                    <Case condition={"purchase"}>
                        <Purchase />
                    </Case>
                </If>
                <SuccessAlert
                    type="success"
                    confirm={"확인"}
                    width={480}
                    height={250}
                    message={
                        <>
                            <h3>라이센스가 변경되었습니다.</h3>
                            {freeLicense && (
                                <p>
                                    {DateWithDayName(purchaseInfo.expDate)} 00시 부터 free 라이센스로
                                    깃발 서비스를 이용하실 수 있습니다.
                                </p>
                            )}
                        </>
                    }
                />
            </NavbarAndSidebarLayout>
        </>
    )
}

export default License
